<!-- App.svelte -->
<script>
  import { statusBarStyle } from './statusbar.js';
  import { createEventDispatcher } from 'svelte';
  import { onMount, onDestroy } from 'svelte';
  import { PushNotifications } from '@capacitor/push-notifications';

  import LoginChecker from './LoginChecker.svelte';
  import LoginForm from './LoginForm.svelte';
  import OTPForm from './OTPForm.svelte';
  import FullNameForm from './FullNameForm.svelte';
  import CityAreaSelection from './CityAreaSelection.svelte';
  import ChangeDeliveryPoint from './ChangeDeliveryPoint.svelte';
  import DeliveryPointSelection from './DeliveryPointSelection.svelte';
  import CategoriesView from './CategoriesView.svelte';
  import ProductsListView from './ProductsListView.svelte';
  import CartSummary from './CartSummary.svelte'; 
  import OrderSuccess from './OrderSuccess.svelte'; 
  import OrderHistory from './OrderHistory.svelte'; 
  import TodayPickups from './TodayPickups.svelte'; 
  import OrderDetails from './OrderDetails.svelte'; 
  import Menu from './Menu.svelte';
  import ProfileView from './ProfileView.svelte';
  import SupportView from './SupportView.svelte'; 
	
  let currentStep = 'loginchecker';
  let user = {};
  let selectedAreaId = null;
  let deliveryPointId = null;
  let selectedCategoryId = null;
  let selectedOrderId = null;
  let checkoutCompleted = false;
  let orderData; 
  let fcmToken = null;
  
  export let name;
  
  let phoneNumber = '';


  onMount(() => {
    statusBarStyle.setDefault();
  });

function handleOtpRequested(event) {
  console.log("OTP requested event received:", event.detail);
  phoneNumber = event.detail.phoneNumber; 
  fcmToken = event.detail.fcmToken; // Use the provided fcmToken, or set it to null for web platforms 
  console.log("Updated phoneNumber:", phoneNumber);
  console.log("Updated fcmToken:", fcmToken);
  currentStep = 'OTPVerify';
}


	function handleOtpRequestedWeb(event) {
	  console.log("OTP requested on web:", event.detail);
	  phoneNumber = event.detail.phoneNumber;
	  fcmToken = 112334444;
	  console.log("Updated phoneNumber:", phoneNumber);
	  console.log("Updated fcmToken:", fcmToken);
	  currentStep = 'OTPVerify';
	}


  function handleBackToLogin() {
    currentStep = 'login';
  }
  


  function handleBackToAreaSelection() {
    currentStep = 'cityAreaSelection';
  }

  

	function handlePleaseLogin() {
	  currentStep = 'login';
	}


  function handleLoginSuccessNoName(event) {
    user = event.detail;
    currentStep = 'fullNameForm';
  }

  function handleNameUpdated() {
    currentStep = 'cityAreaSelection';
  }


  function handleProfileView() {
    currentStep = 'ProfileView';
  }
  
  
	function handleHome() {
	  currentStep = 'categoriesView';
	}

	function handleProfile() {
	  currentStep = 'categoriesView';
	}
	
	function handlePleaseProceed() {
	  currentStep = 'categoriesView';
	}

	function handlePleaseLogout() {
	  console.log("Logging out...");
	  localStorage.removeItem('accessToken');
	  localStorage.removeItem('refreshToken');
	  currentStep = 'login';
	}


	function handleOrderHistory() {
	  console.log("Order history received in main app...");
	  currentStep = 'OrderHistory';
	}

	function handleSupport() {
	  console.log("Support received in main app...");
	  currentStep = 'SupportView';
	}

	function handleTodayPickups() {
	  console.log("Today pickups event received in main app...");
	  currentStep = 'TodayPickups';
	}


	function handleChangePoint() {
	  console.log("Change point request received in main app...");
	  currentStep = 'cityAreaSelection';
	}

	function handleChangeDeliveryPoint() {
	  console.log("Change delivery point request received in main app...");
	  currentStep = 'changeDeliveryPoint';
	}



  // Event listeners
  function handleLoginSuccess(event) {
    user = event.detail;
    currentStep = 'categoriesView';
  }

  // Event listeners
  function handleLoginSuccessNoPoint(event) {
    user = event.detail;
    currentStep = 'cityAreaSelection';
  }


  function handleCityAreaSelection(event) {
    selectedAreaId = event.detail.area;
    currentStep = 'deliveryPointSelection';
  }

  async function handleDeliveryPointSelection(event) {
    deliveryPointId = event.detail.deliveryPointId;
    await updateUserProfile(deliveryPointId);
    currentStep = 'categoriesView';
  }

  async function handleDeliveryPointSelectionChange(event) {
    deliveryPointId = event.detail.deliveryPointId;
    await updateUserProfile(deliveryPointId);
    currentStep = 'ProfileView';
  }



  function handleCategorySelected(event) {
    selectedCategoryId = event.detail.categoryId;
    currentStep = 'productsListView';
  }


	function handleOrderSelection(event) {
	  console.log("Order selection received in main app...");
	  selectedOrderId = event.detail.orderId;
	  currentStep = 'OrderDetails';
	}
	
  function handleBackToProducts(event) {
    selectedCategoryId = event.detail.categoryId;
    currentStep = 'productsListView';
  }

  function handleLoginNeeded() {
    currentStep = 'loginchecker';
  }

  function handlePointNeeded() {
    currentStep = 'cityAreaSelection';
  }

  function handleCheckoutCompleted() {
    checkoutCompleted = true;
    currentStep = 'cartSummary';
  }

  async function updateUserProfile(deliveryPointId) {
    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await fetch('https://groupfruits.online/users/api/UpdateUserProfileView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`,
        },
        body: JSON.stringify({ delivery_point: deliveryPointId }),
      });

      if (response.ok) {
        console.log('Profile updated successfully');
      } else {
        console.error('Error updating user profile:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  }

  function handleOrderPlaced(event) {
    orderData = event.detail;
    currentStep = 'orderSuccess';
  }
</script>


{#if currentStep === 'loginchecker'}
  <LoginChecker on:pleaseLogin={handlePleaseLogin} on:pleaseProceed={handlePleaseProceed} />
  
{:else if currentStep === 'login'}
  <LoginForm on:otpRequestedWeb={handleOtpRequestedWeb} on:otpRequested={handleOtpRequested} on:loginSuccess={handleLoginSuccess} on:loginSuccessNoName={handleLoginSuccessNoName} on:loginSuccessNoPoint={handleLoginSuccessNoPoint} />


{:else if currentStep === 'OTPVerify'}
  <OTPForm {phoneNumber} {fcmToken} on:loginSuccess={handleLoginSuccess} on:loginSuccessNoName={handleLoginSuccessNoName} on:loginSuccessNoPoint={handleLoginSuccessNoPoint} on:backToLogin={handleBackToLogin} />
  {console.log('Rendering OTPForm...')}



{:else if currentStep === 'fullNameForm'}
  <FullNameForm on:nameUpdated={handleNameUpdated} />
  
  
{:else if currentStep === 'cityAreaSelection'}
  <CityAreaSelection on:selectionSuccess={handleCityAreaSelection} on:deliveryPointSelected={handleDeliveryPointSelection} />

{:else if currentStep === 'changeDeliveryPoint'}
  <ChangeDeliveryPoint on:goToProfile={handleProfile} on:selectionSuccess={handleCityAreaSelection} on:deliveryPointSelectedChange={handleDeliveryPointSelectionChange} />
  
{:else if currentStep === 'deliveryPointSelection'}
  <DeliveryPointSelection areaId={selectedAreaId} on:deliveryPointSelected={handleDeliveryPointSelectionChange} on:backToAreaSelection={handleBackToAreaSelection} />
  
{:else if currentStep === 'categoriesView'}
  <CategoriesView on:categorySelected={handleCategorySelected} on:loginNeeded={handleLoginNeeded} on:loginSuccessNoName={handleLoginSuccessNoName} on:pointNeeded={handlePointNeeded} on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory} on:todayPickups={handleTodayPickups} on:pleaseChangePoint={handleChangePoint} on:profileView={handleProfileView}  on:pleaseChangePoint={handleChangePoint} on:pleaseChangeDeliveryPoint={handleChangeDeliveryPoint} />
	
{:else if currentStep === 'productsListView'}
  <ProductsListView categoryId={selectedCategoryId} on:checkoutCompleted={handleCheckoutCompleted} on:pleaseProceed={handlePleaseProceed} />
  
{:else if currentStep === 'cartSummary'}
  <CartSummary on:orderPlaced={handleOrderPlaced} on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory}  on:pleaseChangePoint={handleChangePoint} on:backToProducts={handleBackToProducts} />
  
{:else if currentStep === 'orderSuccess'}
  <OrderSuccess on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory}   on:pleaseChangePoint={handleChangePoint} on:goToHome={handleHome}/>

{:else if currentStep === 'OrderHistory'}
  <OrderHistory on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory} on:orderSelected={handleOrderSelection}   on:pleaseChangePoint={handleChangePoint} on:goToHome={handleHome} on:pleaseOrderHistory={handleOrderHistory}  on:profileView={handleProfileView} />

{:else if currentStep === 'TodayPickups'}
  <TodayPickups on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory} on:orderSelected={handleOrderSelection}   on:pleaseChangePoint={handleChangePoint}/>


{:else if currentStep === 'OrderDetails'}
  <OrderDetails orderId={selectedOrderId} on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory} on:orderSelected={handleOrderSelection}  on:pleaseChangePoint={handleChangePoint} on:OrderList={handleOrderHistory} />

{:else if currentStep === 'ProfileView'}
  <ProfileView  on:goToHome={handleHome} on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory} on:orderSelected={handleOrderSelection}  on:pleaseChangePoint={handleChangePoint} on:pleaseChangeDeliveryPoint={handleChangeDeliveryPoint} on:OrderList={handleOrderHistory} on:pleaseOrderHistory={handleOrderHistory}  on:pleaseSupport={handleSupport} />

{:else if currentStep === 'SupportView'}
  <SupportView on:goToProfile={handleProfileView}  on:goToHome={handleHome} on:pleaseLogout={handlePleaseLogout} on:pleaseOrderHistory={handleOrderHistory} on:orderSelected={handleOrderSelection}  on:pleaseChangePoint={handleChangePoint} on:pleaseChangeDeliveryPoint={handleChangeDeliveryPoint} on:OrderList={handleOrderHistory} on:pleaseOrderHistory={handleOrderHistory}  on:pleaseSupport={handleSupport} />

{:else}
  <p>Placeholder for next step ('products')</p>
{/if}




<head>
    <!-- Meta tags for controlling caching behavior -->
    <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
    <meta http-equiv="Pragma" content="no-cache">
    <meta http-equiv="Expires" content="0">
    <meta name="version" content="1.0">
</head>


